// store/index.js - 简化版本
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      userInfo: null
    }
  },
  getters: {
    userInfo: state => state.user.userInfo || {}
  }
})